// extracted by mini-css-extract-plugin
export default {"containerLoading":"loading-styles_component_containerLoading__wWq+b","textLoading":"loading-styles_component_textLoading__pFQK4","imgGift":"loading-styles_component_imgGift__B2ntB"};